import Vue from 'vue'
import VOfferRowField from "Components/common/VOfferRowField"
import VOfferRow from "Components/common/VOfferRow"
import VInternalAquisitionRow from "Components/common/VInternalAquisitionRow"
import SearchField from "Components/common/SearchField"
import CustomerSelector from "Components/common/CustomerSelector"

Vue.component('v-offer-row-field', VOfferRowField)
Vue.component('v-offer-row', VOfferRow)
Vue.component('v-internal-aquisition-row', VInternalAquisitionRow)

Vue.component('search-field', SearchField)
Vue.component('customer-selector', CustomerSelector)
